import { Stack } from '@mui/material';
import CustomAppBar from 'components/CustomAppBar/CustomAppBar';
import BackButton from 'components/CustomAppBar/components/BackButton/BackButton';
import SubTitle from 'components/CustomAppBar/components/SubTitle/SubTitle';

export default function MyAppBar({ title }) {
  return (
    <CustomAppBar>
      <Stack direction="row">
        <BackButton />
        <SubTitle text={`آمار محتوای ${title}`} />
      </Stack>
    </CustomAppBar>
  );
}
